
import locale from 'element-ui/lib/locale/lang/zh-CN'

export default {
  loadText: '欢迎您访问今日食品品牌官方网站，正在载入，请稍后...',
  title: '宁波今日食品有限公司',
  nav: {
    about: '今日世界',
    products: '今日王国',
    medias: '今日头条',
    contact: '联系我们',
    base: '生产基地',
    human: '人力资源'
  },
  seaTitle: '新鲜生活, 从今日开始',
  homeTitle1: {
    title: '今日王国',
    sub: 'PRODUCTS'
  },
  homeTitle2: {
    title: '今日头条',
    sub: 'NEWS'
  },
  home: {
    deep: {
      title1: '今日倾心',
      title2: '创国际品牌',
      title3: '铸百年基业',
      content: '中国大型的金枪鱼生产基地--宁波今日食品有限公司，创建于2000年，是一家生产经营各类冷冻食品、罐头食品、真空干燥食品、海洋生物产品为主的综合性食品加工型企业。<br>专注于为世界各地人们提供丰富多远的生态绿色、健康营养食品，引领品质生活，并朝着世界食品业知名品牌迈步前行<br>...&nbsp;...',
      ul: [
        '农业产业化国家重点龙头企业',
        '国家级农产品加工示范企业',
        '浙江省农业龙头企业',
        '宁波市出口食品领军企业'
      ],
      count: [
        '员工人数',
        '厂区占地',
        '建筑面积',
        '金枪鱼年加工',
        '数据统计截止2019年1月'
      ]
    },
    Island: {
      text1: '海洋美味 如何演绎？',
      text2: '专业化的捕捞团队',
      text3: '今日依托捕捞资源，已将捕捞鱼群种类范围扩展到太平洋、印度洋以及大西洋西南海域，远洋捕捞实力位居国内一流水平！采用多种围网捕捞、延绳钓等先进捕捞方式。扩大鱼群种类和捕捞深度……'
    },
    what: {
      title: '生态海洋馈赠 · 美味尽在舌尖',
      sub: '金枪鱼的自白',
      info: '我是一名“海洋马拉松”运动员，同时我也是美味营养来源。为什么这么说？因为我肉质肉嫩鲜美，无污染，蛋白石含量高达20%，脂肪含量却很低，俗称“海底鸡”！营养价值高，富含不饱和脂肪酸、DHA、EPA，所含氨基酸齐全含有维生素、丰富的铁、钾、钙、镁、碘等多种矿物质和微量元素，是女性减肥美容的绝佳食品！新鲜美味，营养可口，深受欧美、日本、澳大利亚等顾客的喜爱，是现代人不可多得的健康美食。生态海洋健康美味皆来源于“我”！'

    }
  },
  about: {
    menu: {
      about: '企业介绍',
      story: '品牌故事',
      movie: '形象大片',
      honor: '资质荣誉',
      history: '发展历程'
    },
    base: {
      title: '中国大型的金枪鱼生产基地',
      text: '宁波今日食品有限公司，创建于2000年，是一家生产经营各类冷冻食品、罐头食品、真空干燥食品、海洋生物产品为主的综合性食品出口加工型企业。<br>公司地处风景优美、人文悠久的国家AAAAA级风景区——宁波溪口，现有员工1000余人，厂区占地45000平米，建筑面积30000平米，拥有四千吨以上的冷库。现年产加工金枪鱼50000吨。奋斗与创新让我们取得“浙江省农业龙头企业”，“宁波市出口食品领军企业”等众多殊荣，给予的不仅是企业的信心更是一份责任、一种鞭策。',
      info: [
        '公司顺应国际食品行业发展潮流，审时度势，迎接挑战，不断提升对金枪鱼高值化加工和副产物综合利用，逐步实现金枪鱼精制鱼油、降糖多肽等海洋生物活性物质产业化。将从战略角度重新布局和延伸海洋经济和金枪鱼产业，在生物医药和生命科学领域不断的探索与发展。',
        '专注于为世界各地人们提供丰富多元的生态绿色、健康营养食品，引领品质生活，并朝着世界食品业知名品牌迈步前行！'
      ],
      title2: '健康美味铸口碑 货通天下'
    },
    story: {
      banner: '新鲜生活从今日开始',
      text1: {
        title: '缘起-今日',
        sub: '开拓合作求共赢 誉享全球',
        info: '多年来，公司全体以放眼四海的广博胸怀，开拓勇立潮头的冒险精神，吃苦耐劳的务实品质，永不放弃的顽强意志立足宁波，辐射世界，充沛的生产能力极大满足了欧美、日本众多地区和国家的市场需求，铸就了良好的国际口碑！'
      },
      text2: {
        title: '健康美味铸口碑 货通天下',
        sub: '开拓合作求共赢 誉享全球',
        info: [
          '产品远销美洲、欧洲、中东、日本、澳大利等亚市场，不断开拓新兴市场。目前客户分布已遍布全球五大洲三十多个国家和地区，与行业内世界知名企业建立了长期战略合作关系。建立了完善的国际销售网络，取得了荣誉和信心。',
          '今日以“新鲜生活从今日开始”的理念,致力于为全人类制缔造健康事业的愿景而奋斗。'
        ]
      }
    },
    movie: {
      banner: '形象大片'
    },
    honor: {
      banner: '新鲜生活从今日开始'
    },
    history: {
      banner: '新鲜生活从今日开始'
    }
  },
  productgroups: {
    banner: '唯美食与爱不可辜负',
    brand: {
      title: '生态海洋馈赠·美味尽在舌尖',
      detail: '我是一名“海洋马拉松”运动员，同时我也是美味营养来源。<br>为什么这么说？因为我肉质柔嫩鲜美，无污染，蛋白质含量高达20%，脂肪含量却很低，俗称“海底鸡”！营养价值高，富含不饱和脂肪酸、DHA 、EPA，所含氨基酸齐全含有微生素、丰富的铁、钾、钙、镁、碘等多种矿物质和微量元素，是女性减肥美容的绝佳食品！<br>新鲜味美，营养可口，深受欧美、日本、澳大利亚等顾客的喜爱，是现代人不可多得的健康美食。<br>生态海洋健康美味皆来源于“我”！'
    }
  },
  products: {
    banner: '新鲜生活从今日开始'
  },
  product: {
    head: [
      '品名',
      '净重/固重',
      '口味',
      '包装'
    ]
  },
  medias: {
    banner: '新闻媒体'
  },
  contact: {
    banner: '联系我们',
    title: '宁波今日食品有限公司',
    info: [
      '中国宁波奉化溪口中兴东路38号',
      '邮编：315502',
      '电话：0086-574-88847563',
      '传真：0086-574-88845098',
      '网址：www.todayfood.com.cn',
      '邮箱：todayfood@todayfood.com.cn'
    ],
    content: [
      {
        title: '媒体咨询',
        info: 'E-mail：todayfood@todayfood.com.cn'
      },
      {
        title: '产品咨询',
        info: '产品热线：0086-574-88847563'
      },
      {
        title: '品牌保护',
        info: '投诉建议：0086-574-88847563'
      }
    ]
  },
  human: {
    banner: '天时地利人和',
    content: {
      title: '21世纪什么最重要？',
      sub: '天时不如地利，地利不如人和',
      text: '德才兼备，以德为先',
      info: '公司的人才观定位为“德才兼备、以德为先”我们讲文凭更注重能力，讲才干更注重品德。有德无才难当大任，有才无德实不可用。我们尊重知识、尊重人才，我们强调公司是一个整体，公司更需要团队通力合作，同舟共济。“君子爱财，取之有道”将是公司要求你始终奉行的最起码的道德行为规范。对公司的忠诚、对事业的执着，对自身人品负责，将是衡量你的重要标准。'
    },
    title1: '员工风采',
    title2: '人才招聘'
  },
  job: {
    title: '人才招聘',
    sub: '天时不如地利，地利不如人和',
    form: {
      name: '姓名:',
      sex: {
        label: '性别:',
        placeholder: '请选择性别',
        option: [
          '男',
          '女'
        ]
      },
      marriage: {
        label: '婚姻:',
        placeholder: '请选择婚姻状态',
        option: [
          '未婚',
          '已婚',
          '离异'
        ]
      },
      nation: '民族:',
      age: '年龄:',
      place: '籍贯:',
      edu: {
        label: '文化程度:',
        placeholder: '请选择文化程度',
        option: [
          '专科',
          '本科及以上',
          '其它'
        ]
      },
      school: '毕业学校:',
      major: '专业:',
      time: '毕业时间:',
      lang: '外语水平:',
      post: '应聘岗位:',
      phone: '联系电话:',
      desc: '个人简历:',
      submit: '提交:'
    }
  },
  base: {
    banner: '海洋美味 如何演绎？',
    content: {
      title: '投入一生引以为傲的工作',
      sub: '我们持续取得成功',
      info: [
        {
          title: '始自21世纪品牌经营的沉淀',
          text: '中国大型的金枪鱼生产基地——宁波今日食品有限公司，创建于2000年，是一家生产经营各类冷冻食品、罐头食品、真空干燥食品、海洋生物产品为主的综合性食品出口加工型企业。'
        },
        {
          title: '专业化的捕捞团队',
          text: '采用多种围网捕捞、延绳钓等先进捕捞方式。扩大鱼群种类和捕捞深度，并通过自有运输船队及时将金枪鱼运抵基地进行加工，保证产品第一新鲜。'
        },
        {
          title: '远洋之旅',
          text: '今日依托大洋世家捕捞资源，业已将捕捞鱼群种类范围扩展到太平洋、印度洋以及大西洋西南海域，远洋捕捞实力位居国内一流水平！'
        },
        {
          title: '甄选收获',
          text: '以国际化标准要求自己，把食品安全问题放在首位。严格把关生产过程和食品卫生，保证今日的每一份产品符合生态、绿色的要求。'
        },
        {
          title: '高效化进口设备',
          text: '设备是产品品质的基本保证。公司不断加强生产设备，从丹麦、美国、泰国等地引进FD高科技生产线、金枪鱼蒸煮及装罐设备，整个工艺流程由电脑曲线全自动控制完成，在提高产量的同时确保了产品卓越的品质。'
        },
        {
          title: '国际化质量标准',
          text: '生产过程不仅严格执行ISO9001质量管理体系、ISO22000食品安全管理体系和ISO14001环境管理体系，而且是水产品欧盟注册工厂及输美水产品HACCP验证工厂。产品品质通过 BRC 认证，犹太教OU认证，海豚保护组织EII认证，海洋可持续发展MSC认证。'
        },
        {
          title: '科研投入助开发',
          text: '公司非常重视科研的投入，建立独立的研发中心，拥有20台/套测试分析设备，用于产品质检及新产品研发。与浙江大学、江南大学、宁波大学等高校、科研单位，共同组建了“宁波市食品资源综合利用、深加工产品开发和质量安全控制科技服务团队”，并建成国内第一个金枪鱼综合加工利用和高值化示范基地。'
        },
        {
          title: '精确的拼配',
          text: [
            '所选之优质部位，将经由我们专家之手，根据金枪鱼各自的特性，以最精确的混合与比例控制进行拼配。认真且负责的态度，可满足人们对不同风格口味的偏好：醇厚、甜蜜、均衡、圆润等一切应有尽有。',
            '现有四条金枪鱼罐头生产流水线，十二条鱼柳生产作业线，两条鲭鱼等其他水产品生产线，以及4000吨以上的冷库，年生产各类食品5万吨以上。'
          ]
        }
      ],
      title2: '封藏的美味'
    }
  },
  Morebtn1: '加载更多',
  Morebtn2: '返回产品引导页',
  btn1: '深入了解',
  btn2: '返回',
  btn3: '返回列表',
  btn4: '立即申请',
  swipe1: '社会公益',
  footerTop: {
    text: '新鲜美味生活，从今日开始'
  },
  footerMap: [{
    id: 0,
    title: '今日世界',
    list: [{
      id: 0,
      title: '企业介绍',
      link: '/#/about'
    }, {
      id: 1,
      title: '品牌故事',
      link: '/#/story'
    }, {
      id: 2,
      title: '形象大片',
      link: '/#/movie'
    }, {
      id: 3,
      title: '资质荣誉',
      link: '/#/honor'
    }, {
      id: 4,
      title: '发展历程',
      link: '/#/history'
    }]
  }, {
    id: 1,
    title: '今日王国',
    list: [{
      id: 0,
      title: '金枪鱼罐头',
      link: '/#/products/64'
    }, {
      id: 1,
      title: '金枪鱼鱼柳',
      link: '/#/products/65'
    }, {
      id: 2,
      title: '宠物食品',
      link: '/#/products/66'
    }, {
      id: 3,
      title: '海洋生物健康食品',
      link: '/#/products/67'
    }, {
      id: 4,
      title: '冷冻干燥食品',
      link: '/#/products/99'
    }, {
      id: 5,
      title: '其他产品',
      link: '/#/products/68'
    }]
  }, {
    id: 2,
    title: '生产基地',
    list: [{
      id: 0,
      title: '生产场景',
      link: '/#/base'
    }]
  }, {
    id: 3,
    title: '今日头条',
    list: [{
      id: 0,
      title: '企业动态',
      link: '/#/medias/15'
    }, {
      id: 1,
      title: '媒体聚焦',
      link: '/#/medias/16'
    }, {
      id: 2,
      title: '行业资讯',
      link: '/#/medias/17'
    }]
  }, {
    id: 4,
    title: '人力资源',
    list: [
      {
        id: 0,
        title: '人才战略',
        link: '/#/human'
      }
      // , {
      //   id: 1,
      //   title: '人才招聘',
      //   link: ''
      // }
      // , {
      //   id: 2,
      //   title: '人才招聘'
      // }
    ]
  }, {
    id: 5,
    title: '联系我们',
    list: [{
      id: 0,
      title: '联系方式',
      link: '/#/contact'
    }]
  }],
  footGroup: {
    name: '今日食品',
    add: [
      '中国宁波奉化溪口',
      '中兴东路38号'
    ]
  },
  footLetter: {
    text1: '发送您的邮箱，',
    text2: '第一时间收到反馈！'
  },
  footBottom: {
    text1: '© 1992-2021 .todayfood.com .All Rights Reserved.浙ICP备19020653号-1  ',
    link: [
      '法律声明',
      '版权信息',
      '联系我们'
    ],
    text2: '宁波今日食品有限公司 版权所有 浙ICP备19020653号-1  ',
    text3: [
      '网站建设：',
      '山久网络'
    ]
  },
  mediasLinkNum: '15',
  mediasMenu: [
    {
      id: 0,
      url: '/medias/15',
      text: '企业动态'
    },
    {
      id: 1,
      url: '/medias/16',
      text: '媒体聚焦'
    },
    {
      id: 2,
      url: '/medias/17',
      text: '行业资讯'
    }
  ],
  chooseLang: '语言: 中国大陆',
  langBox: {
    title: '选择语言',
    menu: [
      '中文',
      '英文',
      '日文'
    ]
  },
  // element-ui
  ...locale
}
